import $x from '@/utils/$x';

/**
 * 模板列表
 * @param {*} params
 * @returns
 */
export async function getTTSList(params) {
  return $x.post('/tts/list', params);
}

/**
 * 新增模板
 * @param {*} params
 * @returns
 */
export async function addTTSTemplate(params) {
  return $x.post('/tts/add', params);
}

/**
 * 模板详情
 * @param {*} params
 * @returns
 */
export async function getTTSTemplateDetail(params) {
  return $x.post('/tts/detail', params);
}

/**
 * 修改模板
 * @param {*} params
 * @returns
 */
export async function modifyTTSTemplate(params) {
  return $x.post('/tts/modify', params);
}

/**
 * copy模板
 * @param {*} params
 * @returns
 */
export async function copyTTSTemplate(params) {
  return $x.post('/tts/copy', params);
}

/**
 * 上下架模板
 * @param {*} params
 * @returns
 */
export async function releaseTTSTemplate(params) {
  return $x.post('/tts/release', params);
}

/**
 * 上下架模板
 * @param {*} params
 * @returns
 */
export async function delTTSTemplate(params) {
  return $x.post('/tts/del', params);
}
